import {BrowserRouter as Router, Switch, Route, useHistory} from 'react-router-dom'
import Rise from './components/gift-rise'
import Gift from './components/gift-main'
import HomepageLanding from './components/homepage-landing'
import BannerLanding from './components/banner-landing'
import InnovatorLanding from './components/innovator-landing'
import LargeInnovatorLanding from './components/large-innovator-landing'
import CookieBanner from './widgets/banner/cookie-banner'
import GiftProvider from './context/provider'
import {getUserLocation, setUserLocation} from './components/common/get-user-location'
import {FC, useEffect, useState} from 'react'
import {getParamFromUrl} from './utils/url'
import GA from './shared/tracking/ga'
import Spinner from "./components/common/spinner";
import {getStrapiData} from "./service/user";
import {trackQRCodeOpened} from "./shared/tracking/qr-code-track";

type Props = {
  code: string
  type: string // "basic" | "shared-flight" | "arabic" | "ny-sf" | "home" | 'old'
  isLargeForm: boolean
}

const AppRouting: FC<Props> = ({isLargeForm, code, type}) => {
  const history = useHistory()
  const isBannerLanding = [
    'SXSWLI',
    'SXSWFB',
    'SXSWGG',
    'SXSWSM'
  ].includes(code)

  const isInnovatorLanding = [
    'INNOVATOR',
  ].includes(code)

  const isLargeInnovatorLanding = [
    'RR',
    'CJI22',
    'RT22',
    'NT22',
    'KH22',
    'DG22',
    'AP22',
    'OA22',
    'TAL22',
    'SFR22',
    'TA22',
    'ML22',
    'CH22',
    'AF22',
    'MF22',
    'JJD22',
    'RL22',
    'LF22',
    'HL2022',
    'DAQR',
    'KT22',
    'QT22',
    'MARCHAY',
    'FT22',
    'FH22',
    'MG22',
    'SCOPE22',
    'NYT22',
    'FL22',
    'JB22',
    'PD22',
    'CD22',
    'ZB22',
    'VL22'
  ].includes(code)

  const isHomePageLanding = [
    'DMNYASPENSEATS',
    'NYASPENSEATS',
    'TVNYFLSEATS',
    'TVNYASPENSEATS',
    'METS',
    'GIANTS',
    'JETS',
    'ISLANDERS',
    'RANGERS',
    'KNICKS',
    'PANTHERS',
    'HEAT',
    'POLICE',
    'ASPENTIMES24',
    'FLYXOGGHOMEPAGE',
    'FLYXOFBHOMEPAGE',
    'FLYXOFBHOMEPAGEUK',
    'FLYXOFBHOMEPAGEMENA',
    'SHAREDEXP',

    'MIAMIHERALD',
    'LIFETIME',
    'FLYXOGGMEMBERSHIPPAGE',
    'FLYXOGGFLEETPAGE',
    'FLYXOGGPRIVATEJETCOSTPAGE',
    'FLYXOFBHOMEPAGEEU',
    'FLYXOBGPRIVATEJETCOSTPAGE',
    'FLYXOBGFLEETPAGE',
    'FLYXOBGMEMBERSHIPPAGE',
    'FLYXOBGHOMEPAGE',
    'FLYXOYHPRIVATEJETCOSTPAGE',
    'FLYXOYHFLEETPAGE',
    'FLYXOYHMEMBERSHIPPAGE',
    'FLYXOYHHOMEPAGE',
    'FLYXOGGHOMEPAGEUK',
    'FLYXOGGPRIVATEJETCOSTPAGEUK',
    'FLYXOGGFLEETPAGEUK',
    'FLYXOGGMEMBERSHIPPAGEUK',
    'FLYXOGGHOMEPAGEMENA',
    'FLYXOGGPRIVATEJETCOSTPAGEMENA',
    'FLYXOGGFLEETPAGEMENA',
    'FLYXOGGMEMBERSHIPPAGEMENA',
    'FLYXOGGSHAREDCALENDAR',
    'FLYXOFBSHAREDCALENDAR',
    'FLYXOBGPRIVATEJETCOSTPAGEUK',
    'FLYXOBGFLEETPAGEUK',
    'FLYXOBGMEMBERSHIPPAGEUK',
    'FLYXOBGHOMEPAGEUK',
    'FLYXOBGPRIVATEJETCOSTPAGMENA',
    'FLYXOBGFLEETPAGEMENA',
    'FLYXOBGMEMBERSHIPPAGEMENA',
    'FLYXOBGHOMEPAGEMENA',
    'FLYXOGGSHAREDMENA',
    'FLYXOBGSHAREDMENA',
    'FLYXOFBSHAREDMENA',
    'FLYXOOGHOMEPAGEUS',
    'FLYXOOGHOMEPAGEUK',
    'FLYXOOGHOMEPAGEMENA',
    'FLYXOLIHOMEPAGEUK',
    'FLYXOLIHOMEPAGEMENA',
    'FLYXOAPP',
    'NFT23',
    'WELCOMEGREENWICH',
    'WELCOMEMERCER',
    'WELCOMEBOWERY',
    'WELCOMECHELSEA',
    'MGOLF23',
    'FLYXOTTSHARED',
    'EXEC',
    'SHAREDEXPNYSFL',
    'SHAREDEXPNYASP',


    'FLYXOTTSHAREDNYSFL',

    'FLYXOGGSHAREDNYASP',
    'FLYXOFBSHAREDNYASP',
    'FLYXOTTSHAREDNYASP',

    'SUMMERIN23',
    'FW23',
    'ASPENTIMES23',

    'ASPEN23BMG',
    'SHAREDNYASP',
    'BMGSHAREDNYASP',
    'REALDEAL23',
    'NYFLSEATS',
    'NYASPSEATS',

    'ZOOMNEWYORK',
    'ZOOMFLORIDA',
    'FASHAREDASPEN',
    'FASHAREDNYFL',

    'ZOOMASPEN',
    'ZOOMHAMPTONS',
    'FLYXOGGSHAREDSFLHAMP',
    'FLYXOFBSHAREDSFLHAMP',

    //arabic
    'FLYXOGGHOMEPAGEARG',
    'FLYXOGGPRIVATEJETCOSTPAGEARG',
    'FLYXOGGFLEETPAGEARG',
    'FLYXOGGMEMBERSHIPPAGEARG',
    'FLYXOFBHOMEPAGEUKARG',
    'FLYXOFBHOMEPAGEARG',
    'FLYXOBGPRIVATEJETCOSTPAGARG',
    'FLYXOBGFLEETPAGEARG',
    'FLYXOBGMEMBERSHIPPAGEARG',
    'FLYXOBGHOMEPAGEARG',
  ].includes(code)

  useEffect(() => {
    GA.pageView(window?.location?.pathname)
    history.listen(() => GA.pageView(window.location.pathname))
  }, [history])

  // geo parameter for europe (to show banner for GDPR zone)
  useEffect(() => {
    const userLocation = getUserLocation()

    if (userLocation.eu === '1' || userLocation.country === 'US') {
      setIsBannerOpened(true)
    }
  }, [isBannerLanding, isHomePageLanding, isBannerLanding, isLargeInnovatorLanding])

  const [isBannerOpened, setIsBannerOpened] = useState(false)

  if (isHomePageLanding || type === 'ny-sf' || type === 'home') {
    return (
      <div className="App">
        <Switch>
          <Route exact path="/" component={() => <HomepageLanding type={type} isLargeForm={isLargeForm} lang={type === 'arabic' ? 'ar' : 'en'}/>}/>
        </Switch>
        {isBannerOpened && <CookieBanner/>}
      </div>
    )
  }

  if (isInnovatorLanding) {
    return (
      <div className="App">
        <Switch>
          <Route exact path="/" component={() => <InnovatorLanding isLargeForm={isLargeForm} lang={type === 'arabic' ? 'ar' : 'en'}/>}/>
        </Switch>
        {isBannerOpened && <CookieBanner/>}
      </div>
    )
  }

  if (isBannerLanding) {
    return (
      <div className="App">
        <Switch>
          <Route exact path="/" component={() => <BannerLanding isLargeForm={isLargeForm} lang={type === 'arabic' ? 'ar' : 'en'}/>}/>
        </Switch>
        {isBannerOpened && <CookieBanner/>}
      </div>
    )
  }

  if (isLargeInnovatorLanding || type === 'shared-flight') {
    return (
      <div className="App">
        <Switch>
          <Route exact path="/" component={() => <LargeInnovatorLanding isLargeForm={isLargeForm} lang={type === 'arabic' ? 'ar' : 'en'}/>}/>
        </Switch>
        {isBannerOpened && <CookieBanner/>}
      </div>
    )
  }

  if (type === 'basic' || type === 'arabic') {
    return (
      <div className="App">
        <Switch>
          <Route exact path="/" component={() => <InnovatorLanding isLargeForm={isLargeForm} lang={type === 'arabic' ? 'ar' : 'en'}/>}/>
        </Switch>
        {isBannerOpened && <CookieBanner/>}
      </div>
    )
  }

  return (
    <div className="App">
      <Switch>
        <Route path="/activate_rise">
          <Rise/>
        </Route>
        <Route path="/activate_rise_finish">
          <Rise isFinish/>
        </Route>
        <Route path="/activate_rise_founderscard">
          <Rise founders={true}/>
        </Route>
        <Route path="/mmc">
          <Rise mmc={true}/>
        </Route>
        <Route path="/lang-:lang/" component={Gift}/>
        <Route exact path="/" component={Gift}/>
      </Switch>
      {isBannerOpened && <CookieBanner/>}
    </div>
  )
}

function App() {
  const code = getParamFromUrl('code') ?? ''
  const [isLoading, setIsLoading] = useState(true)
  const [strapiLandingType, setStrapiLandingType] = useState('')
  useEffect(() => {
    getStrapiData(code)
      .then(resStrapi => {
        if (window.document?.URL?.includes('utm_term=qrc')){
          trackQRCodeOpened(code)
        }
        let type = resStrapi?.[0]?.type || 'basic'
        if (resStrapi?.[0]?.popup_landing){
          type = resStrapi?.[0]?.popup_landing
        }
        if (!resStrapi?.[0]) {
          type = 'old'
        }
        setUserLocation()
          .then(() => {
            setStrapiLandingType(type)
            setIsLoading(false)
          })
      })
  }, [code])

  if (isLoading || !strapiLandingType) {
    return (
      <div className='main-loader'>
        <Spinner/>
      </div>
    )
  }

  return (
    <GiftProvider isLargeForm={strapiLandingType !== 'arabic'}>
      <Router>
        <AppRouting isLargeForm={strapiLandingType !== 'arabic'} type={strapiLandingType} code={code}/>
      </Router>
    </GiftProvider>
  )
}

export default App
